import type { QueryFilterConfig } from '@/types/common/table-config.type';

// should check by role customer/ktv?
export const query: QueryFilterConfig = objFilter => {
    return {};
};
